import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../../OneModal/OneModal'
import { Button, Typography } from '@mui/material'
import { showNotify, formatDateTime, separateDateTime } from '../../../Utils/Utils'
import { prioridades } from '../../../Utils/optionsEventos'
import { useContext, useEffect, useState } from 'react'
import OneTextArea from '../../OneTextArea/OneTextArea'
import OneSelect from '../../OneSelect/OneSelect'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import OneInput from '../../OneInput/OneInput'
import { tiposOrdemServico } from '../../../Utils/optionsSelects'
import { Close } from "@mui/icons-material"
import { OrdemServicoContext } from '../../../Providers/OrdemServicoContext/OrdemServicoContext'
import moment from 'moment';

const container = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'start',
    gap: '7px'
}

const line = {
    display: 'flex',
    gap: '150px'
}

const formGroup = {
    display: 'flex',
    gap: '10px'
}

const formGroupTextValue = {
    fontWeight: 'bold'
}

const formGroupLabel = {
    width: '130px'
}

const textAreaSx = {
    height: '60px'
}

const ModalFecharOrdemServico = ({ open, setOpen, ordemServicoRef }) => {
    const ordemServico = { ...ordemServicoRef }

    if (!ordemServico) {
        showNotify('error', 'Houve um erro ao buscar ordem de serviço.')
        return
    }

    [ordemServico.data_cadastro, ordemServico.hora_cadastro] = separateDateTime(formatDateTime(ordemServico.data_cadastro), ' ');
    [ordemServico.data_fechamento, ordemServico.hora_fechamento] = separateDateTime(formatDateTime(ordemServico.data_fechamento), ' ')

    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { buscarOrdensServico } = useContext(OrdemServicoContext)

    const [formData, setFormData] = useState({})
    const [optionsTecnicos, setOptionsTecnicos] = useState([{ id: 0, nome: 'Selecionar' }])
    const [uploadedAnexos, setUploadesAnexos] = useState([])

    useEffect(() => {
        addRoute('buscarListagens#modalFecharOrdemServico', (msg) => {
            const { status, message } = msg.data

            if (status === 'error' || !status) {
                showNotify('error', message)
                return
            }

            let tecnicos = msg.data?.listagens?.tecnico

            tecnicos.unshift({ id: 0, nome: 'Selecionar' })

            setOptionsTecnicos(tecnicos)
        })

        sendWs('buscarListagens#modalFecharOrdemServico', {
            listagens: {
                tecnico: ["id", "nome"]
            }
        })
    }, [])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const onAddAnexo = async (e) => {
        const files = [...uploadedAnexos]

        for (let i = 0; i < e.target.files.length; i++) {
            files.push(e.target.files[i])
        }

        await setUploadesAnexos(files)
    }

    const addFile = () => {
        const input = document.getElementById('inputImage')
        input.click()
    }

    const deleteFile = (index) => {
        const files = uploadedAnexos.filter((file, i) => i !== index)

        setUploadesAnexos(files)
    }

    const handleSubmit = () => {
        const dataHoraFechamento = separateDateTime(moment().format('YYYY-MM-DD HH:mm'), ' ');

        formData.anexos = uploadedAnexos
        formData.id = ordemServico.id

        if (formData.tecnico !== undefined) {
            if (formData.tecnico == 0) {
                delete formData.tecnico
            }
        }

        if (!formData.data_fechamento) {
            formData.data_fechamento = dataHoraFechamento[0]
        }

        if (!formData.hora_fechamento) {
            formData.hora_fechamento = dataHoraFechamento[1]
        }

        if (formData.data_fechamento) {
            if (formData.hora_fechamento) {
                formData.data_fechamento = `${formData.data_fechamento} ${formData.hora_fechamento}`
            } else {
                formData.data_fechamento = `${formData.data_fechamento} 00:00:00.000`
            }
            delete formData.hora_fechamento
        }

        addRoute('fecharOrdemServico', (msg) => {
            const { status, message } = msg.data

            if (status == 'error' || !status) {
                showNotify('error', message)
                return
            }

            showNotify('success', 'Ordem de serviço finalizada com sucesso!')
            setOpen(false)
            buscarOrdensServico()
        })

        sendWs('fecharOrdemServico', {
            ordemServico: formData
        })
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText="Fechar Ordem Serviço"
            fullWidth={true}
        >
            <Grid sx={container}>
                <Grid sx={line}>
                    <Grid sx={formGroup}>
                        <Typography sx={formGroupLabel}>Ordem Serviço: </Typography>
                        <Typography sx={formGroupTextValue}>{ ordemServico.id }</Typography>
                    </Grid>

                    <Grid sx={formGroup}>
                        <Typography>Cliente: </Typography>
                        <Typography sx={formGroupTextValue}>{ ordemServico.condominio }</Typography>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup}>
                        <Typography>
                            Aberta por <span style={formGroupTextValue}>{ ordemServico.nome_usuario_cadastro }</span> em <span style={formGroupTextValue}>{ ordemServico.data_cadastro }</span> às <span style={formGroupTextValue}>{ ordemServico.hora_cadastro }</span>
                        </Typography>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup}>
                        <Typography sx={formGroupLabel}>Motivo/Defeito: </Typography>
                        <Grid>
                            <Typography sx={formGroupTextValue}>{ ordemServico.motivo }</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs={3}>
                        <Typography sx={formGroupLabel}>Tipo: </Typography>
                        <Grid xs={1}>
                            <Typography sx={formGroupTextValue}>{ tiposOrdemServico.getOne(ordemServico.tipo).descricao }</Typography>
                        </Grid>
                    </Grid>

                    <Grid sx={formGroup} xs={3}>
                        <Typography>Prioridade: </Typography>
                        <Typography sx={{ ...formGroupTextValue, color: prioridades[ordemServico.prioridade - 1].color }}>{ prioridades[ordemServico.prioridade - 1].nome }</Typography>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography sx={formGroupLabel}>Observações: </Typography>
                        <Grid xs>
                            <OneTextArea
                                defaultValue={ordemServico.observacao}
                                name="observacao"
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography sx={formGroupLabel}>Técnico: </Typography>
                        <Grid xs>
                            <OneSelect
                                options={optionsTecnicos}
                                defaultValue={ordemServico.tecnico || optionsTecnicos[0].id}
                                name="tecnico"
                                label="nome"
                                valor="id"
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={{ ...line, gap: '20px' }}>

                    <Grid sx={formGroup}>
                        <Typography sx={formGroupLabel}>Fechamento: </Typography>
                        <Grid>
                            <OneInput
                                defaultValue={ordemServico.data_fechamento}
                                type="date"
                                name="data_fechamento"
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid sx={formGroup}>
                        <Typography>Hora: </Typography>
                        <OneInput
                            defaultValue={ordemServico.hora_fechamento}
                            type="time"
                            name="hora_fechamento"
                            onChange={handleChange}
                        />
                    </Grid>

                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography sx={formGroupLabel}>Causa: </Typography>
                        <Grid xs>
                            <OneTextArea
                                defaultValue={ordemServico.causa}
                                name="causa"
                                onChange={handleChange}
                                newSx={textAreaSx}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography sx={formGroupLabel}>Solução: </Typography>
                        <Grid xs>
                            <OneTextArea
                                defaultValue={ordemServico.solucao}
                                name="solucao"
                                onChange={handleChange}
                                newSx={textAreaSx}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography>Adicionar Anexo: </Typography>
                        <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <Grid>
                                <input id="inputImage" type="file" accept="image/*" onChange={onAddAnexo} style={{ display: 'none' }} multiple/>
                                <Button size='small' variant="contained" color="one_primary" onClick={addFile}>Procurar Arquivo</Button>
                            </Grid>
                            <Grid sx={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                {uploadedAnexos.map((file, i) => {
                                    return (
                                        <span style={{ display: 'flex' }}>
                                            {file.name}
                                            <Close style={{ color: 'red' }} onClick={() => deleteFile(i)}/>
                                        </span>
                                    )
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid sx={{ ...line, justifyContent: 'end', gap: '150px' }}>
                    {/* <Grid sx={{ ...formGroup, alignItems: 'center' }}>
                        <OneSwitch
                            defaultValue={ordemServico.notificar_sindico_whatsapp}
                            name="notificar_sindico_whatsapp"
                            onChange={handleChange}
                        />
                        <Typography>Notificar Síndico via Whats</Typography>
                    </Grid> */}

                    <Button variant="contained" color="one_primary" onClick={handleSubmit}>Finalizar</Button>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default ModalFecharOrdemServico
